module.exports = __webpack_public_path__ + "assets/img/popup-scan.2c87f280.png";